import { ICouponProgram, ICouponService } from "@interfaces";
import React, { memo, useEffect } from "react";
import * as Yup from "yup";
import { Input, Form, Row, Col, FormInstance } from "antd";
import { useYup } from "@validations";
import { useTranslation } from "react-i18next";

import { FormAction } from "@components";
import { PATH_CDIC_COUPON_LIST } from "@configs";
import { setLoading } from "@redux";
import { getApiErrorMessage, useCreateService, useNotify } from "@utils";
import { useHistory } from "react-router";
import { useDispatch } from "react-redux";
import { SharedButton } from "@components";

interface IProps {
  coupon?: ICouponService;
  onSuccess?: () => void;
}

const initValue: Partial<ICouponService> = {
  serviceName: "",
  status: "ACTIVE",
};

export const CdicServiceForm = memo(({ coupon, onSuccess }: IProps) => {
  const formRef = React.useRef<FormInstance>(null);
  const { YupService } = useYup();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const { success, error } = useNotify();
  const createService = useCreateService();
  const couponSchema = Yup.object().shape(YupService);
  const [couponForm] = Form.useForm();

  useEffect(() => {
    dispatch(setLoading(createService.isPending));
  }, [dispatch, createService.isPending]);

  const onFinish = async (values: ICouponService) => {
    try {
      if (!coupon || !coupon._id) {
        await createService.mutateAsync({ ...values });
      }
      success(t("message.create.success"));
      onSuccess?.();
      history.push(PATH_CDIC_COUPON_LIST);
    } catch (err) {
      error(getApiErrorMessage(err, t("message.create.fail")));
    }
  };

  const onFinishFailed = (errorInfo: any) => {
    console.log("Failed:", errorInfo);
  };

  const yupSync = {
    async validator({ field }: any, value: any) {
      await couponSchema.validateSyncAt(field, { [field]: value });
    },
  };

  return (
    <Form
      form={couponForm}
      name="basic"
      ref={formRef}
      initialValues={initValue}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
      layout="vertical"
    >
      <Row gutter={{ md: 54, lg: 54 }}>
        <Col lg={12} md={24} sm={24} xs={24}>
          <Form.Item label={t("page.service_name")} name="serviceName" rules={[yupSync]}>
            <Input />
          </Form.Item>
        </Col>
        <Col lg={12} md={24} sm={24} xs={24}>
          <div style={{height: '30px'}} />
          <SharedButton type="primary" htmlType="submit" size="middle">
            {t("page.create")}
          </SharedButton>
        </Col>
      </Row>
    </Form>
  );
});
